exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-menu[data-v-605789ac]{transform:translate3d(0,38px,0)!important}", ""]);

// exports
